<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div class="item-icon-container" *ngIf="characterClass !== null">
  <div *ngFor="let entries of disabledItems; let idx = index">
    <div *ngIf="idx === 1 && entries.length > 0">Helmets</div>
    <div *ngIf="idx === 2 && entries.length > 0">Gauntlets</div>
    <div *ngIf="idx === 3 && entries.length > 0">Chest Pieces</div>
    <div *ngIf="idx === 4 && entries.length > 0">Legs</div>
    <div *ngIf="idx === 5 && entries.length > 0">Class Items</div>

    <span *ngFor="let i of entries; let idx = index" class="item-sub">
      <img
        class="item-icon"
        loading="lazy"
        src="https://bungie.net/{{ i.icon }}"
        (click)="enableItem(i.itemInstanceId)"
        matTooltipClass="allow-cr"
        [matTooltip]="generateTooltip(i)" />
      <br *ngIf="(idx + 1) % 10 === 0" />
    </span>
  </div>
</div>
